import type { ReactNode } from "react";
import { useAuth } from "./AuthContext.js";

/**
 * Renders `children` only for an authenticated session; otherwise `fallback`. No URL-based
 * routing exists yet (nothing to deep-link to until Phase 4's builder), so this is deliberately a
 * plain guard rather than a route-matching component — the same shape a real route guard will
 * wrap once react-router is added for actual multi-page navigation.
 */
export const ProtectedRoute = ({
  children,
  fallback,
}: {
  children: ReactNode;
  fallback: ReactNode;
}): JSX.Element => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  return <>{user ? children : fallback}</>;
};
